

<template>
    <div class="commission-order-wrapper" v-if="orderListData.length>0">
        <van-pull-refresh v-model="isLoading" @refresh="pullDownRefresh">
            <img slot="loading" :src="loadingSrc" class="boms-loading-sm">
            <img slot="normal" :src="loadingSrc" class="boms-loading-sm">
            <img slot="pulling" :src="loadingSrc" class="boms-loading-sm">
            <img slot="loosing" :src="loadingSrc" class="boms-loading-sm">
            <van-list v-model="pullUpLoading" :finished="isMaxData" @load="pullUpLoadData">
                <list-of-order
                    type="commission"
                    v-for="(item, index) of orderListData"
                    :key="index"
                    :item="item"
                ></list-of-order>
            </van-list>
        </van-pull-refresh>
    </div>
    <div class="no-result" v-else>
        <img :src="noorderSrc">
        <p>暂无推广订单</p>
    </div>
</template>

<script>
import ListOfOrder from "@/components/ListOfOrder";
export default {
    name: "UserCommissionList",
    components: { ListOfOrder },
    props: {},
    data() {
        return {
            isLoading: false,
            pullUpLoading: false,
            isMaxData: false,
            currentPage: 0,
            orderListData: [],
            numberInEachPage: 10,
            loadingSrc: "",
            noorderSrc: ""
        };
    },
    computed: {},
    watch: {},
    created() {
        this.pullDownRefresh();
        wx.ready(function () {
            UTILS.hiddenMenu();
        });
    },
    provide() {
        return {
            pullDownRefresh: this.pullDownRefresh
        };
    },
    mounted() {
        this.loadingSrc = API.ossUrl + "yyq/loading.gif";
        this.noorderSrc = API.ossUrl + "yyq/empty_icons/noorder.png";
    },
    destroyed() {},
    methods: {
        getOrderListFromPage(number = 1) {
            return this.$axios.get(
                `${API.user.getCommissionList}/${number}/${
                    this.numberInEachPage
                }?token=${sessionStorage.token}`
            );
        },
        //下拉刷新
        pullDownRefresh() {
            let vm = this;
            this.getOrderListFromPage(1)
                .then(({ data }) => {
                    if (data.code == 200) {
                        let res = data.data;
                        vm.orderListData = res.list;
                        vm.isLoading = false;
                        vm.currentPage = 1;
                        vm.isMaxData = res.pageNo >= res.pageCount;
                    } else {
                        vm.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        },
        //上拉加载
        pullUpLoadData(number) {
            let vm = this;
            this.getOrderListFromPage(vm.currentPage + 1)
                .then(({ data }) => {
                    if (data.code == 200) {
                        let res = data.data;
                        vm.orderListData = vm.orderListData.concat(res.list);
                        vm.pullUpLoading = false;
                        vm.currentPage = Number(res.pageNo);
                        vm.isMaxData = res.pageNo >= res.pageCount;
                    } else {
                        vm.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        }
    }
};
</script>


<style scoped lang="scss">
.commission-order-wrapper {
    background: $grey2;
    min-height: 100%;
    width: 100%;
}
.no-result {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #666;
    font-size: 16px;
    flex-direction: column;
    margin-top: 42%;
    img {
        margin-bottom: 0.666667rem;
        width: 7.386667rem;
        height: 5.666667rem;
    }
    p {
        color: #444444;
        font-size: 14px;
        text-align: center;
        font-weight: bold;
    }
}
</style>

